"use client";

import {
  PixelEvent,
  PixelMetadata,
  usePixelTracking,
} from "@/hooks/usePixelTracking";
import { useEffect, useRef } from "react";

export function Pixel({
  eventName,
  eventSlug,
  metadata,
}: {
  eventSlug: string;
  eventName: PixelEvent;
  metadata?: PixelMetadata;
}) {
  const { track, isSuccess } = usePixelTracking({
    eventSlug: eventSlug,
  });
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!isSuccess || hasTracked.current) {
      return;
    }

    hasTracked.current = true;
    track({
      eventName,
      metadata,
    });
  }, [eventName, isSuccess, metadata, track]);

  return null;
}
